import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import Header from '../Header';
import { MOBILE_MIN_WIDTH } from '../../../../utils';
import { useMediaQuery } from 'react-responsive';
import BackwardButton from '../../../Button/components/BackwardButton/BackwardButton';

interface Props {
	className?: string;
	title: string;
	onClickBackward?: () => void;
	onClose?: () => void;
}

const FullscreenModalHeader: React.FC<Props> = ({ className, title, onClickBackward, onClose }) => {
	const { FullscreenModalHeader: css } = useTheme('BaseComponents');

	const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });

	const showBackwardButton = Boolean(isMobile && onClickBackward);

	const titleRender = () => (
		<div className={css.title__wrapper}>
			{showBackwardButton && <BackwardButton variant="icon" onClick={onClickBackward} />}

			<span className={css.title}>{title}</span>
		</div>
	);

	return (
		<Header showEmptySlots={false} left={titleRender()} onClose={onClose} className={cn(css.header, className)} />
	);
};

export default FullscreenModalHeader;
